export default {
	contact_information_action_email: 'E-Mail schreiben',
	contact_information_action_open_record: 'Datensatz öffnen',
	contact_information_action_phone: 'Anrufen',
	contact_information_close: 'Schließen',
	contact_information_column_action: 'Aktion',
	contact_information_column_display_text: 'Name',
	contact_information_column_display_value: 'Kontakt',
	contact_information_column_record: 'Datensatz',
	contact_information_dialog_title: 'Kontaktieren',
	contact_information_empty_initial_caption: 'Geben Sie einen Suchbegriff ein, um Kontaktdaten zu finden.',
	contact_information_empty_initial_title: 'Noch keine Suche',
	contact_information_empty_search_caption: 'Ändern Sie den Suchbegriff oder den Filter.',
	contact_information_empty_search_title: 'Keine Kontaktdaten gefunden',
	contact_information_filter_all: 'Alle',
	contact_information_filter_email: 'E-Mail',
	contact_information_filter_email_addresses: 'E-Mail-Adressen',
	contact_information_filter_email_aria_label: 'E-Mail-Filter umschalten',
	contact_information_filter_email_tooltip: 'E-Mail-Kontakte filtern',
	contact_information_filter_phone: 'Telefon',
	contact_information_filter_phone_aria_label: 'Telefonfilter umschalten',
	contact_information_filter_phone_numbers: 'Telefonnummern',
	contact_information_filter_phone_tooltip: 'Telefonkontakte filtern',
	contact_information_filter_type_aria_label: 'Kontakttyp filtern',
	contact_information_launcher_tooltip: 'Kontaktieren',
	contact_information_search_label: 'Kontaktdaten suchen',
	contact_information_search_pending_caption: 'Die Kontaktdaten werden geladen.',
	contact_information_search_pending_title: 'Suche läuft',
};
